import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { DialogActions, Grid } from "@material-ui/core";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import millimeterMask from "Components/Input/components/millimeterMask";
import * as R from "ramda";
import { read } from "Helpers/LocalStorage";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import { EditRokub, GetAllRokub } from "Stores/actions";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import { useTranslation } from 'react-i18next';
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import * as Icons from "react-bootstrap-icons";

function RokubRowEditor({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { rokubDataPagination, rokubDataSearch } = useSelector((state) => ({
    rokubDataPagination: state.rokub.rokubDataPagination,
    rokubDataSearch: state.rokub.rokubDataSearch,
  }));
  const [formValid, setFormValid] = useState({});
  const [showDialog, setShowDialog] = useState(false);
  const [change, setChange] = useState(false);
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useSetState({
    name: {
      type: "text",
      value: row.Name,
      validation: {
        required: true,
      },
      auth: true,
    },
    size: {
      type: "millimeter",
      value: row.Size,
      validation: {
        required: true,
        isNumeric: true,
        minLength: 1,
        maxLength: 3,
        min: 9,
      },
      auth: true,
    },
    groupPrice: {
      type: "price",
      value: row.GroupPrice,
      validation: {
        required: true,
        isPrice: true,
        notZero: true,
      },
      auth: read("StypeU") === "1",
    },
    userPrice: {
      type: "price",
      value: row.UserPrice,
      validation: {
        required: true,
        isPrice: true,
      },
      auth: read("StypeU") === "2" || read("StypeU") === "5",
    },
  })
  
  const handleDialog = () => {
    setShowDialog(!showDialog);
  }

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  }

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    if(change) {
      const { name, groupPrice, size, userPrice } = controls;
      if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
      ) {
        let price;
        if (groupPrice.auth) {
          price = +groupPrice.value;
        } else {
          price = +userPrice.value;
        }
        try {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: +row.Id,
            Size: +size.value,
            Name: name.value,
            Price: price,
          };
          await dispatch(EditRokub(data));
          handleDialog();
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Name: rokubDataSearch?.Name,
            Limit: rokubDataPagination.Limit,
            Page: rokubDataPagination.Page,
          };
          await dispatch(GetAllRokub(params));
          onClear();
        } catch (e) {
          showNotify({
            text: t('correctFormDataRequired'),
            customClass: "error",
          });
        }
        handleDialog();
      } else if (R.isEmpty(formValid)) {
        handleDialog();
      } else {
        showNotify({
          text: t('correctFormDataRequired'),
          customClass: "error",
        });
      }
    } else {
      handleDialog();
    }
    setLoading(false);
  }

  const onEnter = async () => {
    onClear();
  }

  const onClear = () => {
    setFormValid({ name: true, size: true, groupPrice: true });
    setControls({ name: { value: row.Name } });
    setControls({ size: { value: row.Size } });
    setControls({ groupPrice: { value: row.GroupPrice } });
    setControls({ userPrice: { value: row.UserPrice } });
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <ActionFormatter
        title={<Translator id="virayesh" />}
        icon={<Icons.Pencil size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={
          (row.IsG &&
              read("StypeU") !== "1") ||
          read("rokubRules")?.accessUpdate === false ||
          row.Disable
        }
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="virayesh_Rokub" />
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={2} className="d-flex">
              {
                Object.keys(controls).filter(key => controls[key].auth).map((key, index) => {
                  return (
                    <Grid item xs={12} key={key + index}>
                      <Input
                        setValue={setValue.bind(this)}
                        value={controls[key].value}
                        name={key}
                        placeholder={t(key)}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        type={controls[key].type}
                        inputComponent={controls[key].type === "millimeter" ? millimeterMask : ''}
                        endIcon={controls[key].type === "price" ? <Translator id='moneyUnit' /> : controls[key].type === "millimeter" ? <Translator id='millimeter' /> : ''}
                        minLength={controls[key]?.validation?.minLength}
                        maxlength={controls[key]?.validation?.maxLength}
                      />
                    </Grid>
                  )
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default RokubRowEditor;
